var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 66.375C46.2538 66.375 47.3047 65.9509 48.1528 65.1028C49.0009 64.2547 49.425 63.2038 49.425 61.95C49.425 60.6963 49.0009 59.6453 48.1528 58.7972C47.3047 57.9491 46.2538 57.525 45 57.525C43.7463 57.525 42.6953 57.9491 41.8472 58.7972C40.9991 59.6453 40.575 60.6963 40.575 61.95C40.575 63.2038 40.9991 64.2547 41.8472 65.1028C42.6953 65.9509 43.7463 66.375 45 66.375ZM40.575 48.675H49.425V22.125H40.575V48.675ZM45 88.5C38.8787 88.5 33.1263 87.3384 27.7425 85.0153C22.3588 82.6922 17.6756 79.5394 13.6931 75.5569C9.71062 71.5744 6.55781 66.8913 4.23469 61.5075C1.91156 56.1238 0.75 50.3713 0.75 44.25C0.75 38.1287 1.91156 32.3763 4.23469 26.9925C6.55781 21.6088 9.71062 16.9256 13.6931 12.9431C17.6756 8.96062 22.3588 5.80781 27.7425 3.48469C33.1263 1.16156 38.8787 0 45 0C51.1213 0 56.8738 1.16156 62.2575 3.48469C67.6413 5.80781 72.3244 8.96062 76.3069 12.9431C80.2894 16.9256 83.4422 21.6088 85.7653 26.9925C88.0884 32.3763 89.25 38.1287 89.25 44.25C89.25 50.3713 88.0884 56.1238 85.7653 61.5075C83.4422 66.8913 80.2894 71.5744 76.3069 75.5569C72.3244 79.5394 67.6413 82.6922 62.2575 85.0153C56.8738 87.3384 51.1213 88.5 45 88.5Z",
    fill: "#C00F0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/paymentError.f8177e9a1ea6bf6b96e2ef5d4a4c4ff4.svg";
export { ForwardRef as ReactComponent };